// @router
import { checkAuthenticated, loginType } from "@/shared/utils";
import { ensurePreRegisterFlow } from "@/modules/auth/services";

const authLayout = () => import("@/layouts/AuthLayout.vue");
const auth = () => import("../views/auth.vue");
const forgetPassword = () => import("../views/forget-password.vue");
const contactUs = () => import("../views/contact-us.vue");
const authMobile = () => import("../views/auth-mobile.vue");
const activeRegistrations = () =>
  import("../views/pre-register/active-registrations.vue");
const detailRegistrations = () =>
  import("../views/pre-register/detail-registrations.vue");
const personalInformation = () =>
  import("../views/pre-register/personal-information.vue");
const resultRegistrations = () =>
  import("../views/pre-register/result-registrations.vue");

export const authRoutes: any[] = [
  {
    path: "/auth",
    name: "auth",
    redirect: loginType() === "send-code" ? "/auth/auth-mobile" : "/auth/login",
    component: authLayout,
    meta: {
      redesigned: true,
      moduleName: "auth",
    },
    children: [
      {
        path: "login",
        name: "auth-username",
        component: auth,
        meta: {
          redesigned: true,
          label: "ورود",
        },
        beforeEnter: async (to: any, from: any, next: any) => {
          const isAuthenticated = await checkAuthenticated();
          if (isAuthenticated) {
            next({
              name: "dashboard",
            });
          } else {
            next();
          }
        },
      },
      {
        path: "auth-mobile",
        name: "auth-mobile",
        component: authMobile,
        meta: {
          redesigned: true,
          label: "ورود با رمز یکبارمصرف",
        },
      },
      {
        path: "forget-password",
        name: "forget-password",
        component: forgetPassword,
        meta: {
          redesigned: true,
          label: "فراموشی رمز عبور",
        },
      },
      {
        path: "contact-us",
        name: "contact-us",
        component: contactUs,
        meta: {
          redesigned: true,
          label: "ثبت مشکلات ورود",
        },
      },
    ],
  },
  {
    path: "/pre-register",
    name: "pre-register",
    redirect: "/pre-register/active-registrations",
    component: authLayout,
    meta: {
      redesigned: true,
      moduleName: "auth",
      label: "ثبت نام",
    },
    children: [
      {
        path: "active-registrations",
        name: "active-registrations",
        component: activeRegistrations,
        meta: {
          redesigned: true,
          label: "ثبت نام",
        },
      },
      {
        path: "detail-registrations/:code",
        name: "detail-registrations",
        component: detailRegistrations,
        meta: {
          redesigned: true,
          label: "ثبت نام",
        },
      },
      {
        path: "personal-information",
        name: "personal-information",
        component: personalInformation,
        meta: {
          redesigned: true,
          label: "ثبت نام",
        },
        beforeEnter: async (_to: any, _from: any, next: any) => {
          const isValid = await ensurePreRegisterFlow();
          if (isValid) {
            next();
          } else {
            next({ name: "active-registrations", replace: true });
          }
        },
      },
      {
        path: "result-registrations",
        name: "result-registrations",
        component: resultRegistrations,
        meta: {
          redesigned: true,
          label: "ثبت نام",
        },
      },
    ],
  },
];
